export default "__VITE_ASSET__663af5f4__"